import moment from 'moment'
import { ALL_LOCALES, NORMALIZED_MOMENT_LOCALE_IMPORT_MAP } from './define-moment-locales-import-map'

// Locale to fallback in the map in case it is not in the list of locales supported from moment
const FALLBACK_LOCALE = 'en-gb'

// Excluded locales to fallback. This is because there are user implementations about localized
// formats that relies in this specific locale plus the internal moment locale.
const EXCLUDED_FALLBACK_LOCALES = ['en-US']

export const getMomentLanguageCode = locale => {
    if (typeof locale !== 'string') {
        return FALLBACK_LOCALE
    }
    const lowercaseLocale = locale.toLowerCase()
    const [languageCode] = lowercaseLocale.split('-')
    if (NORMALIZED_MOMENT_LOCALE_IMPORT_MAP[lowercaseLocale]) {
        return lowercaseLocale
    } else if (NORMALIZED_MOMENT_LOCALE_IMPORT_MAP[languageCode]) {
        return languageCode
    }
    return FALLBACK_LOCALE
}

export const getLocaleImport = locale => {
    const langCode = getMomentLanguageCode(locale)
    return NORMALIZED_MOMENT_LOCALE_IMPORT_MAP[langCode]
}

/**
 * Define the locales internally for moment. Moment supports list of locales
 * as it is ALL_LOCALES (NORMALIZED_MOMENT_LOCALE_IMPORT_MAP keys)
 *
 * @param {string[]} supportedLocales - List of the supported locales
 * @param {*} excludedLocalesFromFallback - List of locales that will not have fallback locale (en-GB) if not in ALL_LOCALES.
 *      This is, the fallback will be the internal one for moment (EN).
 */
export const defineMomentLocales = (
    supportedLocales = ALL_LOCALES,
    excludedLocalesFromFallback = EXCLUDED_FALLBACK_LOCALES
) => {
    return Promise.all(
        supportedLocales.map(locale => {
            if (excludedLocalesFromFallback.includes(locale)) {
                return Promise.resolve()
            }

            const importFn = getLocaleImport(locale)

            return importFn()
                .then(momentLocaleData => {
                    moment.defineLocale(getMomentLanguageCode(locale), momentLocaleData.default['_config'])
                })
                .catch(() => {
                    console.error(`Error: Moment.js could not define locale for ${locale}`)
                })
        })
    )
}
